import React from 'react';
import loadImg from '../../assets/img/loading-big.png';

interface IProps {
  readonly isLoading: boolean;
  readonly height?: string;
  readonly width?: string;
}

export const Loading = (props: IProps) => {
  if (!props.isLoading) {
    return null; // 如果不是加载状态,无内容
  }

  const containerStyle = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: props.height || '50px',
    width: props.width || '100%',
  };

  const imageStyle = {
    animation: props.isLoading ? 'spin 1s linear infinite' : 'none',
    height: '48px',
    width: '48px',
  };
  const animationStyle = `
    @keyframes spin {
        0% {
        transform: rotate(0deg);
        }
        100% {
        transform: rotate(360deg);
        }
    }
    `;

  return (
    <div style={containerStyle} className="loading-content">
      <img src={loadImg} alt="Loading" style={imageStyle} />
      {props.isLoading && <style>{animationStyle}</style>}
    </div>
  );
};
